module.exports = __webpack_public_path__ + "media/Loops Perc.01333e70.wav";